// Returns the pixel offset that scroll-to-element code should subtract from
// a target's absolute Y position so that the target lands just below the
// sticky nav (which can grow taller when items wrap to a second row).
//
// The personal-share banner is position: relative and scrolls away with the
// page, so it is NOT included -- only the sticky nav affects overlap after
// the user has scrolled.
export function getScrollOffset(extraBuffer = 16) {
  if (typeof document === 'undefined') return 120;
  const nav = document.querySelector('[data-sticky-nav]');
  const navH = nav ? nav.getBoundingClientRect().height : 64;
  return Math.round(navH + extraBuffer);
}
